module.exports = __webpack_public_path__ + "img/pin_take_away_green.32994cb5.svg";